import { Space } from 'antd';
import { FC } from 'react';

import { CopyableText, DescriptionBlock, HiddenPassword } from '@/common/components';
import { BaseQueryParams } from '@/common/interfaces';
import { CommonDrawerTitle } from '@/common/layouts';

import { useGetByIdCloudflareAccountsQuery } from '@/modules/DomainsApi/Cloudflare';

import { CloudflareAccountsOverviewDropdown } from './CloudflareAccountsOverviewDropdown';

interface Props {
  cloudflareAccount: BaseQueryParams<typeof useGetByIdCloudflareAccountsQuery>['data'];
  isDeleteCloudflareAccountLoading: boolean;
  isDeleteCloudflareAccountDisabled: boolean;
  handleDeleteCloudflareAccount: () => void;
  handleEditCloudflareAccount: () => void;
}

export const CloudflareAccountsOverviewView: FC<Props> = ({
  cloudflareAccount,
  isDeleteCloudflareAccountLoading,
  isDeleteCloudflareAccountDisabled,
  handleDeleteCloudflareAccount,
  handleEditCloudflareAccount
}) => {
  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Space>
            <CloudflareAccountsOverviewDropdown
              isItemsDisabled={ isDeleteCloudflareAccountDisabled || isDeleteCloudflareAccountLoading }
              isDeleteCloudflareAccountLoading={ isDeleteCloudflareAccountLoading }
              handleDeleteCloudflareAccount={ handleDeleteCloudflareAccount }
              handleEditCloudflareAccount={ handleEditCloudflareAccount }
            />
          </Space>
        }
      />

      <DescriptionBlock
        items={
          [['Email', (
            <CopyableText key="cloudflareAccount.email" textToCopy={ cloudflareAccount.email }>
              { cloudflareAccount.email }
            </CopyableText>
          )]]
        }
      />

      <DescriptionBlock items={ [['Пароль', <HiddenPassword key="password" password={ cloudflareAccount.password }/>]] }/>

      <DescriptionBlock items={ [['API ключ', <HiddenPassword key="apiKey" password={ cloudflareAccount.apiKey }/>]] }/>
    </>
  );
};
